import { ReactElement, useEffect, useRef } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { Input } from '@weareopenr/component-library';
import { EMAIL_VALIDATION_REGEX } from 'src/constants/regex';
import { useWizard } from '../../MultistepWizard/WizardContext';
import { IFormValues } from '../types';
import styles from '../UserModal.module.scss';

export const UserDetailsStep = (): ReactElement => {
  const { data } = useWizard<IFormValues>();
  const updateDataRef = useRef(data.updateData);

  const {
    control,
    watch,
    formState: { errors },
  } = useForm<Pick<IFormValues, 'first_name' | 'last_name' | 'email'>>({
    defaultValues: {
      first_name: data.data.first_name || '',
      last_name: data.data.last_name || '',
      email: data.data.email || '',
    },
    mode: 'onChange',
  });

  const firstName = watch('first_name');
  const lastName = watch('last_name');
  const email = watch('email');

  // Keep ref updated
  useEffect(() => {
    updateDataRef.current = data.updateData;
  }, [data.updateData]);

  // Update wizard data when form fields change
  useEffect(() => {
    if (updateDataRef.current) {
      updateDataRef.current({
        first_name: firstName,
        last_name: lastName,
        email: email,
      });
    }
  }, [firstName, lastName, email]);

  return (
    <div>
      <div className={styles['form-field']}>
        <Controller
          name="first_name"
          control={control}
          rules={{
            required: 'Please enter a name',
            validate: (value) => value.trim() !== '' || 'Please enter a name',
          }}
          render={({ field: { ref: _, ...field } }) => (
            <Input
              {...field}
              id="firstname"
              type="text"
              label="First Name"
              error={errors.first_name?.message}
            />
          )}
        />
      </div>
      <div className={styles['form-field']}>
        <Controller
          name="last_name"
          control={control}
          rules={{
            required: 'Please enter a name',
            validate: (value) => value.trim() !== '' || 'Please enter a name',
          }}
          render={({ field: { ref: _, ...field } }) => (
            <Input
              {...field}
              id="lastname"
              type="text"
              label="Last Name"
              error={errors.last_name?.message}
            />
          )}
        />
      </div>
      <div className={styles['form-field']}>
        <Controller
          name="email"
          control={control}
          rules={{
            required: 'Please enter an email address',
            pattern: {
              value: EMAIL_VALIDATION_REGEX,
              message: 'Invalid email address',
            },
          }}
          render={({ field: { ref: _, ...field } }) => (
            <Input {...field} id="email" type="text" label="Email" error={errors.email?.message} />
          )}
        />
      </div>
    </div>
  );
};
